import { Injectable, Signal, signal } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class ViewportService {
  private static readonly MOBILE_QUERY = '(max-width: 767px)'

  private readonly mediaQuery = globalThis.matchMedia(ViewportService.MOBILE_QUERY)
  private readonly isMobileSignal = signal(this.mediaQuery.matches)

  public readonly isMobile: Signal<boolean> = this.isMobileSignal.asReadonly()

  constructor() {
    this.mediaQuery.addEventListener('change', (event) => {
      this.isMobileSignal.set(event.matches)
    })
  }
}
